/**
 * Render if condition component
 */
type IRenderIf = {
    /**
     * Condition to render
     */
    show: boolean;
    children: React.ReactNode;
};

const RenderIf = ({ show, children }: IRenderIf) => {
    if (!show) {
        return null;
    }

    return <>{children}</>;
};

export default RenderIf;
